// extracted by mini-css-extract-plugin
export default {"logoContainer":"Landing_logoContainer__iuoLU"};